export type A2hsPlatform = "ios" | "android" | "other";

export const getA2hsPlatform = (): A2hsPlatform => {
  if (typeof navigator === "undefined") return "other";

  const ua = navigator.userAgent;
  if (/iPad|iPhone|iPod/.test(ua)) return "ios";
  // iPadOS 13+ may report as Macintosh with touch support.
  if (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1) return "ios";
  if (/Android/i.test(ua)) return "android";
  return "other";
};

/** Mobile / tablet devices where add-to-home-screen is relevant. */
export const isA2hsPromptDevice = (): boolean => {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return false;
  }

  const platform = getA2hsPlatform();
  if (platform === "ios" || platform === "android") return true;

  // Touch tablets/phones with a non-mobile UA string.
  return (
    navigator.maxTouchPoints > 0 &&
    window.matchMedia("(pointer: coarse)").matches
  );
};

export const isRunningAsInstalledPwa = (): boolean => {
  if (typeof window === "undefined") return false;

  const displayModeStandalone =
    window.matchMedia("(display-mode: standalone)").matches ||
    window.matchMedia("(display-mode: fullscreen)").matches ||
    window.matchMedia("(display-mode: minimal-ui)").matches;

  const iosStandalone =
    "standalone" in window.navigator &&
    (window.navigator as Navigator & { standalone?: boolean }).standalone ===
      true;

  return displayModeStandalone || iosStandalone;
};

/** Chrome/Firefox/Edge on iOS cannot add a proper home-screen web app. */
export const isIosSafari = (): boolean => {
  if (getA2hsPlatform() !== "ios") return false;
  const ua = navigator.userAgent;
  // iPadOS desktop-mode Safari has no "Safari" token the same way; treat as Safari.
  if (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1) {
    return !/CriOS|FxiOS|OPiOS|EdgiOS|DuckDuckGo/i.test(ua);
  }
  const isSafari = /Safari/i.test(ua);
  const isOtherBrowser = /CriOS|FxiOS|OPiOS|EdgiOS|DuckDuckGo/i.test(ua);
  return isSafari && !isOtherBrowser;
};
